import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(public authService: AuthenticationService, private httpClient: HttpClient) {}

  getAllAgents() {
    const url = `/user/getUsers`;
    const data = {
      OnlineUser: false,
      OnlySup: true,
    };
    return this.httpClient.post(url, data);
  }

  getUserRoles(clientId: string) {
    const url = `/user/role?clientId=${clientId}`;
    return this.httpClient.get(url);
  }

  getUsersList(payload: any) {
    const url = `/user/getuserslist`;
    return this.httpClient.post(url, payload);
  }

  getUserById(id: string) {
    const url = `/user/${id}`;
    return this.httpClient.get(url);
  }

  postUser(data: any) {
    const url = `/user`;
    return this.httpClient.post(url, data);
  }

  updateUser(data: any) {
    const url = `/user`;
    return this.httpClient.put(url, data);
  }

  updateUsersCampaign(data: any) {
    const url = `/user/userscampaign`;
    return this.httpClient.put(url, data);
  }

  updateUsersPriority(data: any) {
    const url = `/user/usersPriority`;
    return this.httpClient.put(url, data);
  }

  activateUser(id: string) {
    const url = `/user/activate`;
    return this.httpClient.put(url, {
      Id: id,
    });
  }

  deactivateUser(id: string) {
    const url = `/user/deactivate`;
    return this.httpClient.put(url, {
      Id: id,
    });
  }

  resetUserPassword(userId: string) {
    const url = `/user/resetpassword`;
    return this.httpClient.put(url, {
      Id: userId,
      Token: '',
      NewPassword: '',
      IsDefaultPassword: true, //* Default pasword
    });
  }

  checkUserNameExists(payload: {ibexId?: string, username?: string}) {
    const { ibexId, username } = payload;
    // return of({ exists: false });
    let url = `/user/users/search`;
    if(ibexId){
      url += `?IbexId=${ibexId}`;
    } else if(username){
      url += `?Username=${username}`;
    }
    return this.httpClient.get<any>(url);
  }

  userClone(payload: any) {
    let url = `/user/clone`;
    return this.httpClient.post<any>(url, payload);
  }

  forceLogoutUser(userId: string) { 
    const url = `/user/admin-forceLogout`;
    return this.httpClient.put(url, { UserId: userId });
  }

  validateBulkUsersCampaign(data: any) {
    const url = `/user/bulkUsersCampaign/validate`;
    return (this.httpClient as any).disableLoader
      ? (this.httpClient as any).disableLoader().post(url, data, { headers: { hideLoader: 'true' } })
      : this.httpClient.post(url, data, { headers: { hideLoader: 'true' } });
  }

  bulkUpdateUsersCampaign(data: any) {
    const url = `/user/bulkUsersCampaign`;
    return (this.httpClient as any).disableLoader
      ? (this.httpClient as any).disableLoader().put(url, data, { headers: { hideLoader: 'true' } })
      : this.httpClient.put(url, data, { headers: { hideLoader: 'true' } });
  }

  validateTeamStructure(data: any) {
    const url = `/user/teamStructure/validate`;
    return (this.httpClient as any).disableLoader
      ? (this.httpClient as any).disableLoader().post(url, data, { headers: { hideLoader: 'true' } })
      : this.httpClient.post(url, data, { headers: { hideLoader: 'true' } });
  }

  bulkUpdateTeamStructure(data: any) {
    const url = `/user/teamStructure`;
    return (this.httpClient as any).disableLoader
      ? (this.httpClient as any).disableLoader().put(url, data, { headers: { hideLoader: 'true' } })
      : this.httpClient.put(url, data, { headers: { hideLoader: 'true' } });
  }
}
